import { render, staticRenderFns } from "./CreateUserLoyaltyDialog.vue?vue&type=template&id=0482322e&scoped=true"
import script from "./CreateUserLoyaltyDialog.vue?vue&type=script&lang=js"
export * from "./CreateUserLoyaltyDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateUserLoyaltyDialog.vue?vue&type=style&index=0&id=0482322e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0482322e",
  null
  
)

export default component.exports